import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Input,
  DataGrid,
} from '../../../components/index';
import Masks from '../../../utils/masks';

const CronogramaPagamento = (props) => {
  const verificaSeCampoDesabilitado = (nomeCampo) => {
    const { acao } = { ...props.estadoFormulario };
    if (acao === 'detalhar') {
      return true;
    }
    if (acao === 'novo' && nomeCampo === 'competencia' && props.estadoFormulario.cronogramaPagamento.ano !== null && props.estadoFormulario.cronogramaPagamento.ano !== '0') {
      return true;
    }
    if (acao === 'novo' && nomeCampo === 'competencia' && props.estadoFormulario.cronogramaPagamento.ano === '0') {
      return false;
    }
    if (acao === 'alterar' && nomeCampo === 'competencia') {
      return true;
    }
    return false;
  };

  return (
    <React.Fragment>
      <DataGrid title="Dados do Cronograma" icon="ico-calendar" >
        <div className="row">
          <Grid cols="6 6 6 6">
            <Input
              disabled={verificaSeCampoDesabilitado('competencia')}
              error={!props.estadoFormulario.validadeCampos.competencia}
              label="Competência"
              value={props.estadoFormulario.cronogramaPagamento.competencia}
              onChange={e => props.handleChange(e, 'competencia')}
              mask={Masks.competencia}
            />
          </Grid>
          <Grid cols="6 6 6 6">
            <Input
              disabled={verificaSeCampoDesabilitado('dataCND')}
              error={!props.estadoFormulario.validadeCampos.dataCND}
              touched={props.estadoFormulario.touched}
              mask={Masks.date}
              label="CND"
              value={props.estadoFormulario.cronogramaPagamento.dataCND}
              onChange={e => props.handleChange(e, 'dataCND')}
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="6 6 6 6">
            <Input
              disabled={verificaSeCampoDesabilitado('dataObitos')}
              error={!props.estadoFormulario.validadeCampos.dataObitos}
              touched={props.estadoFormulario.touched}
              mask={Masks.date}
              label="Consulta de Óbitos"
              value={props.estadoFormulario.cronogramaPagamento.dataObitos}
              onChange={e => props.handleChange(e, 'dataObitos')}
            />
          </Grid>
          <Grid cols="6 6 6 6">
            <Input
              disabled={verificaSeCampoDesabilitado('dataFechamentoPrevia')}
              error={!props.estadoFormulario.validadeCampos.dataFechamentoPrevia}
              touched={props.estadoFormulario.touched}
              mask={Masks.date}
              label="Fechamento da Prévia"
              value={props.estadoFormulario.cronogramaPagamento.dataFechamentoPrevia}
              onChange={e => props.handleChange(e, 'dataFechamentoPrevia')}
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="6 6 6 6">
            <Input
              disabled={verificaSeCampoDesabilitado('dataConsultaPrevia')}
              error={!props.estadoFormulario.validadeCampos.dataConsultaPrevia}
              touched={props.estadoFormulario.touched}
              mask={Masks.date}
              label="Início do Período de Consulta da Prévia"
              value={props.estadoFormulario.cronogramaPagamento.dataConsultaPrevia}
              onChange={e => props.handleChange(e, 'dataConsultaPrevia')}
            />
          </Grid>
          <Grid cols="6 6 6 6">
            <Input
              disabled={verificaSeCampoDesabilitado('dataFechamentoFolha')}
              error={!props.estadoFormulario.validadeCampos.dataFechamentoFolha}
              touched={props.estadoFormulario.touched}
              mask={Masks.date}
              label="Fechamento da Folha de Pagamento COMPREV"
              value={props.estadoFormulario.cronogramaPagamento.dataFechamentoFolha}
              onChange={e => props.handleChange(e, 'dataFechamentoFolha')}
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="6 6 6 6">
            <Input
              disabled={verificaSeCampoDesabilitado('dataRelatoriosBG')}
              error={!props.estadoFormulario.validadeCampos.dataRelatoriosBG}
              touched={props.estadoFormulario.touched}
              label="Disponibilização dos Relatórios de Pagamento (Carga BG)"
              value={props.estadoFormulario.cronogramaPagamento.dataRelatoriosBG}
              onChange={e => props.handleChange(e, 'dataRelatoriosBG')}
              mask={Masks.date}
            />
          </Grid>
          <Grid cols="6 6 6 6">
            <Input
              disabled={verificaSeCampoDesabilitado('dataEnvioBB')}
              error={!props.estadoFormulario.validadeCampos.dataEnvioBB}
              touched={props.estadoFormulario.touched}
              mask={Masks.date}
              label="Envio do Arquivo do BB"
              value={props.estadoFormulario.cronogramaPagamento.dataEnvioBB}
              onChange={e => props.handleChange(e, 'dataEnvioBB')}
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="6 6 6 6">
            <Input
              disabled={verificaSeCampoDesabilitado('dataPrazoPagamento')}
              error={!props.estadoFormulario.validadeCampos.dataPrazoPagamento}
              touched={props.estadoFormulario.touched}
              mask={Masks.date}
              label="Prazo para Pagamento dos Valores"
              value={props.estadoFormulario.cronogramaPagamento.dataPrazoPagamento}
              onChange={e => props.handleChange(e, 'dataPrazoPagamento')}
            />
          </Grid>
          <Grid cols="6 6 6 6">
            <Input
              disabled={verificaSeCampoDesabilitado('dataPrazoDefesa')}
              error={!props.estadoFormulario.validadeCampos.dataPrazoDefesa}
              touched={props.estadoFormulario.touched}
              mask={Masks.date}
              label="Marco Limite para Defesa (Informação Pagamento Rejeitado)"
              value={props.estadoFormulario.cronogramaPagamento.dataPrazoDefesa}
              onChange={e => props.handleChange(e, 'dataPrazoDefesa')}
            />
          </Grid>
          <Grid cols="6 6 6 6">
            <Input
              disabled={verificaSeCampoDesabilitado('dataPrazoAnalise')}
              error={!props.estadoFormulario.validadeCampos.dataPrazoAnalise}
              touched={props.estadoFormulario.touched}
              mask={Masks.date}
              label="Marco Limite para Análise de Pagamento Rejeitado"
              value={props.estadoFormulario.cronogramaPagamento.dataPrazoAnalise}
              onChange={e => props.handleChange(e, 'dataPrazoAnalise')}
            />
          </Grid>

        </div>
      </DataGrid>
    </React.Fragment>
  );
};

CronogramaPagamento.propTypes = {
  // acao: PropTypes.string.isRequired,
  // auth: PropTypes.objectOf(PropTypes.object).isRequired,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default CronogramaPagamento;



// WEBPACK FOOTER //
// ./src/pages/cadastros/cronograma-pagamentos/DadosCronogramaPagamento.jsx